import { render, staticRenderFns } from "./areaNewsTypeList.vue?vue&type=template&id=794a9768&scoped=true"
import script from "./areaNewsTypeList.vue?vue&type=script&lang=js"
export * from "./areaNewsTypeList.vue?vue&type=script&lang=js"
import style0 from "./areaNewsTypeList.vue?vue&type=style&index=0&id=794a9768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794a9768",
  null
  
)

export default component.exports